// Order is the row order in the Payments & reminders section.
export enum AutomaticPaymentRemindersType {
  OnDueDate = 'onDueDate',
  BeforeDueDate = 'beforeDueDate',
  AfterDueDate = 'afterDueDate',
}
